import PropTypes from 'prop-types';
import InWishListSummary from './InWishListSummary';
import SuggestedPanel from './SuggestedPanel';
import CustomColorPicker from '../CustomColorPicker';
import GoFetch from '~/js/modules/fetchling';
import ReactLoader from '~/js/components/global/ReactLoader';
import OwlCarousel from 'react-owl-carousel';

const internals = {};
const cdnPath = '//cdn.sandals.com/sandals';

internals.sliderOptions = {
    className: 'owl-theme',
    touchDrag: true,
    mouseDrag: true,
    lazyLoad: true,
    nav: false,
    items: 1,
    responsive: {
        768: {
            nav: true
        }
    }
};

const attributeFetch = new GoFetch();
const suggestedFetch = new GoFetch();

export default class ItemPanel extends React.Component {
    static propTypes = {
        itemData: PropTypes.object,
        isSuccessAdded: PropTypes.bool,
        wishListModified: PropTypes.string,
        userId: PropTypes.number,
        modalUpdateHandler: PropTypes.func,
        isSuccessAddedHandler: PropTypes.func,
        isSignUpHandler: PropTypes.func
    };

    static defaultProps = {
        itemData: {},
        wishListModified: '',
        isSuccessAddedHandler: () => null,
        modalUpdateHandler: () => null,
        isSignUpHandler: () => null
    };

    constructor(props) {
        super(props);
        this.state = {
            showSuggested: true,
            suggestedItems: []
        };
    }
    componentDidUpdate(nextProps) {
        const owl = $('.owl-carousel');

        if (this.props.itemData !== nextProps.itemData) {
            this._fetchSuggestedItems();
            $('.suggested-loader').show();
            $('.suggested-container').hide();
            $('#itemSize')
                .val(this.props.itemData.currentAttributeId)
                .trigger('change');
            owl.removeClass('owl-hidden');
        }

        const close = document.getElementsByClassName('mfp-close')[0];

        if (close) {
            close.onclick = () => {
                fetch('/fetchAccountInfo/')
                    .then(response => {
                        return response.json();
                    })
                    .then(accountInfo => {
                        if (accountInfo.data.isAuthenticated) {
                            window.location.reload();
                        }
                    });
            };
        }
    }
    _fetchSuggestedItems = () => {
        const requestBody = {
            attributeId: `${this.props.itemData.currentAttributeId}`
        };

        suggestedFetch
            .post('/weddings/items/suggested/', null, requestBody)
            .then(resp =>
                this.setState({ suggestedItems: resp.data.suggestedItems })
            )
            .catch(err => console.warn(err));
    };
    _getCurrentPrice = () => {
        const itemData = this.props.itemData;
        const destinationSelect = $('#dropdown-price option:selected').val();
        const quantityValue = $('#quantity').val();
        const currentIndex = itemData.priceList.findIndex(
            el => el.region.id === parseInt(destinationSelect, 10)
        );
        let thePrice;
        const hiddenPriceFlag = itemData.priceList[currentIndex].hiddenPrice;

        if (this.props.isEdit && currentIndex === -1) {
            // If the above condition is met, it means that the item we're currently trying to display
            // has a regionId of 0 which means its price does not vary between regions
            thePrice = itemData.priceList[0].price;
        } else {
            thePrice = itemData.priceList[currentIndex].price;
        }

        itemData.destinationPrice = thePrice;
        itemData.quantity = quantityValue;
        itemData.total = thePrice * quantityValue;
        itemData.currentRegionId = parseInt(destinationSelect, 10);
        itemData.hiddenPriceFlag = hiddenPriceFlag;

        this.props.modalUpdateHandler(itemData);
    };
    _getDestination = priceList => {
        return priceList.map(el => (
            <option key={el.region.id} value={el.region.id}>
                {_.capPhrase(el.region.name.toLowerCase())}
            </option>
        ));
    };

    _getItemSizes = sizeList => {
        return sizeList.map(el => (
            <option key={el.id} value={el.id}>
                {_.capPhrase(el.size.toLowerCase())}
            </option>
        ));
    };
    _getItemOnDropdownChange = e => {
        const select = e.target;
        const currentOption = select.options[select.selectedIndex].value;

        this._fetchItemByAttributeId(currentOption);
    };
    _fetchItemByAttributeId = currentAttributeId => {
        const requestBody = {
            attributeId: currentAttributeId,
            userId: this.props.userId
        };
        const itemContent = document.querySelector('.item-details');

        // _.loaderHelper();
        $('.sk-loader-item').show();
        itemContent.classList.add('hide');

        attributeFetch
            .post('/weddingStyler/item/details/', null, requestBody)
            .then(resp => {
                const { data = {} } = resp;
                const { itemDetails: itemData = [] } = data;

                const destinationSelect = $(
                    '#dropdown-price option:selected'
                ).val();
                const quantityValue = $('#quantity').val();
                const currentIndex = itemData.priceList.findIndex(
                    el => el.region.id === parseInt(destinationSelect, 10)
                );
                const currentRegionId =
                    itemData.priceList[currentIndex].region.id;
                const hiddenPriceFlag =
                    itemData.priceList[currentIndex].hiddenPrice;
                const thePrice = itemData.priceList[currentIndex].price;

                itemData.destinationPrice = thePrice;
                itemData.quantity = quantityValue;
                itemData.total = thePrice * quantityValue;
                itemData.currentAttributeId = currentAttributeId;
                itemData.currentRegionId = currentRegionId;
                itemData.hiddenPriceFlag = hiddenPriceFlag;

                this.props.modalUpdateHandler(itemData);
                this.props.isSuccessAddedHandler(false);
            })
            .then(() => {
                itemContent.classList.remove('hide');
                $('.sk-loader-item').hide();
            })
            .catch(err => console.warn(err));
    };

    _getTotalByQuantity = () => {
        const itemData = this.props.itemData;
        const quantity = $('input[name="quantity"]').val();

        itemData.quantity = quantity;

        if (itemData.destinationPrice > 0) {
            const total = quantity * itemData.destinationPrice;

            itemData.total = total;
            this.props.modalUpdateHandler(itemData);
        } else {
            const total = quantity * itemData.price;

            itemData.total = total;
            this.props.modalUpdateHandler(itemData);
        }
    };
    _toggleShowSuggested = () => {
        // e.preventDefault();
        this.setState({ showSuggested: !this.state.showSuggested });
    };
    _validationOnlyNumbers = e => {
        const a = [];
        const k = e.which;

        for (let i = 48; i < 58; i++) {
            a.push(i);
        }

        if (!($.inArray(k, a) >= 0)) {
            e.preventDefault();
        }
    };
    _onDashBoardModalBtnClick = () => {
        this.props.isSignUpHandler(true);
        $.magnificPopup.open({
            items: {
                src: '#dashboard-modal',
                type: 'inline'
            }
        });
        $('html, body').animate(
            {
                scrollTop: $('#dashboard-modal').offset().top
            },
            500
        );
    };
    _renderMultipleImages = imageList =>
        imageList.map((image, index) => {
            if (image.imageFullPath) {
                return (
                    <img
                        key={index}
                        src={`${cdnPath}${image.imageFullPath}`}
                        alt={'Item detail preview'}
                        className="img-responsive use-attributes"
                    />
                );
            }
        });

    render() {
        const { itemData = {}, isSuccessAdded, wishListModified } = this.props;
        const sizeList = itemData.sizeList
            ? this._getItemSizes(itemData.sizeList)
            : [];
        const hasSizeList = itemData.sizeList
            ? itemData.sizeList.length > 0
            : '';
        const hasColorList = itemData.colorList
            ? itemData.colorList.length > 0
            : '';
        const destinationList = itemData.priceList
            ? this._getDestination(itemData.priceList)
            : [];
        const hasWishLists = itemData.wishLists
            ? itemData.wishLists.length
            : [];
        const firstRegionName = itemData.priceList
            ? itemData.priceList[0].region.name
            : '';
        const itemsCount = this.state.suggestedItems.length;
        const quantity = $('#quantity').val();
        const imageListLength = itemData.imageList
            ? itemData.imageList.length
            : 0;
        const imageItemList = itemData.imageList
            ? this._renderMultipleImages(itemData.imageList)
            : [];

        return (
            <div className="item-details">
                <div className="intro-details">
                    <span className="item-special-code">
                        {itemData.specialEventCode}
                    </span>
                    <h2 className="item-title">{itemData.description}</h2>
                    <p className="desc-copy">{itemData.longDescription}</p>
                </div>
                {hasWishLists ? (
                    <InWishListSummary foundWishlists={itemData.wishLists} />
                ) : null}
                {imageListLength > 1 ? (
                    <OwlCarousel {...internals.sliderOptions}>
                        {imageItemList}
                    </OwlCarousel>
                ) : (
                    <img
                        src={`${
                            imageListLength
                                ? `${cdnPath}${itemData.imageList[0].imageFullPath}`
                                : `${cdnPath}/wedding-styler/small/no-img.jpg`
                        }`}
                        alt={itemData.description}
                        className="img-responsive use-attributes"
                    />
                )}

                <div className="container-fluid options">
                    <div className="row info-price-wrapper">
                        <div className="xs-12">
                            <div className="row center-xs">
                                <label
                                    htmlFor="dropdown-price"
                                    className="item-details-label price xs-12 lg-2"
                                >
                                    Item Price:
                                </label>
                                <div
                                    className={`xs-12 lg-5 control-wrapper custom-ddl price-dropdown ${
                                        firstRegionName !== 'ALL REGIONS'
                                            ? 'show'
                                            : 'hide'
                                    }`}
                                >
                                    <select
                                        name="dropdown-price"
                                        id="dropdown-price"
                                        onChange={this._getCurrentPrice}
                                        required
                                    >
                                        {destinationList}
                                    </select>
                                </div>
                                {firstRegionName !== 'ALL REGIONS' ? (
                                    <big
                                        className={`xs-12 lg-2 big-price ${
                                            itemData.hiddenPriceFlag
                                                ? 'hide'
                                                : 'show'
                                        }`}
                                    >
                                        {`${
                                            itemData.total
                                                ? `$${itemData.total}`
                                                : `${
                                                      itemData.destinationPrice
                                                          ? `$${itemData.destinationPrice}`
                                                          : `$${itemData.price}`
                                                  }`
                                        }`}
                                    </big>
                                ) : (
                                    <big
                                        className={`xs-12 lg-1 big-price alone ${
                                            itemData.hiddenPriceFlag
                                                ? 'hide'
                                                : 'show'
                                        }`}
                                    >{`$${
                                        itemData.total
                                            ? itemData.total
                                            : itemData.price
                                    }`}</big>
                                )}
                                <strong
                                    className={`${
                                        firstRegionName === 'ALL REGIONS'
                                            ? 'xs-12 lg-4'
                                            : 'xs-12 lg-4'
                                    } call-for-pricing-dest ${
                                        itemData.hiddenPriceFlag
                                            ? 'show'
                                            : 'hide'
                                    }`}
                                >
                                    <strong>Call for pricing</strong>{' '}
                                    1-877-SANDALS
                                </strong>
                            </div>
                        </div>
                    </div>
                    <div className="row center-xs size-color-quantity">
                        <div
                            className={`size-wrapper xs-12 lg-4 ${
                                hasSizeList ? 'show' : 'hide'
                            }`}
                        >
                            <label
                                htmlFor="itemSize"
                                className="item-details-label"
                            >
                                Size
                            </label>
                            <div className="control-wrapper custom-ddl size">
                                <select
                                    name="itemSize"
                                    id="itemSize"
                                    onChange={this._getItemOnDropdownChange}
                                    required
                                >
                                    {sizeList}
                                </select>
                            </div>
                        </div>

                        {hasColorList ? (
                            <CustomColorPicker
                                itemColors={itemData.colorList}
                                currentItemColor={itemData.color}
                                fetchItemByAttributeId={
                                    this._fetchItemByAttributeId
                                }
                            />
                        ) : null}

                        <div className="xs-6 lg-4">
                            <label
                                htmlFor="quantity"
                                className="item-details-label"
                            >
                                Quantity:
                            </label>
                            <div className="control-wrapper">
                                <input
                                    name="quantity"
                                    type="text"
                                    id="quantity"
                                    onKeyPress={this._validationOnlyNumbers}
                                    onChange={this._getTotalByQuantity}
                                    defaultValue="1"
                                    min="1"
                                    maxLength="4"
                                    required
                                />
                            </div>
                        </div>
                        <div className="xs-12 add-wrapper">
                            <a
                                onClick={this._onDashBoardModalBtnClick}
                                className={`add-to-wishlist ${
                                    quantity > 0 ? 'active' : ''
                                }`}
                            >
                                add to a wishlist
                            </a>
                        </div>
                        <span
                            className={`${
                                isSuccessAdded ? 'success-add xs-12' : 'hide'
                            }`}
                        >{`${itemData.quantityAdded} item(s) added to ${wishListModified}`}</span>
                    </div>
                </div>
                <div className="suggested-wrapper">
                    <ReactLoader className={'suggested-loader'} />
                    {itemsCount > 0 ? (
                        <SuggestedPanel
                            suggestedItems={this.state.suggestedItems}
                            showSuggested={this.state.showSuggested}
                            userId={this.props.userId}
                            modalUpdateHandler={this.props.modalUpdateHandler}
                            showSuggestedHandler={this._toggleShowSuggested}
                            isSuccessAddedHandler={
                                this.props.isSuccessAddedHandler
                            }
                        />
                    ) : (
                        ''
                    )}
                </div>
            </div>
        );
    }
}
